import type { FunctionComponent } from 'react'
import React from 'react'
import {
  StyledModal,
  Title,
  Content,
  CustomButton
} from './ModalNotYourSchool.styles'

const ARVORE_EMAIL = 'atendimento@arvore.com.br'

interface ModalProps {
  isSchool?: boolean
  showModal: boolean
  dismissModal: () => void
}

const ModalNotYourSchool: FunctionComponent<ModalProps> = ({
  isSchool = true,
  showModal,
  dismissModal
}) => {
  const title = isSchool ? 'Não é essa escola' : 'Não encontro o estudante'
  const text = isSchool
    ? `
    Vamos te ajudar. Primeiro verifique o código digitado e tente novamente. 
    Se não funcionar, entre em contato com a gente informando:
    `
    : 'Vamos te ajudar. Entre em contato com a gente informando:'

  return (
    <StyledModal show={showModal} onClose={dismissModal} canCloseByXBtn={false}>
      <Title>{title}</Title>
      <Content>
        {text}
        <ul>
          <li>
            <b>Nome da escola,</b>
          </li>
          <li>
            <b>Cidade,</b>
          </li>
          <li>
            <b>Estado,</b>
          </li>
          <li>
            <b>Nome completo do estudante</b> e
          </li>
          <li>
            <b>Turma</b> ou <b>Ano escolar do estudante</b>.
          </li>
        </ul>
        {isSchool ? (
          <>
            Envie as informações para{' '}
            <a href={`mailto:${ARVORE_EMAIL}`}>{ARVORE_EMAIL}</a> ou inicie um
            chat com nosso atendimento.
          </>
        ) : (
          <>
            Entre em contato conosco por{' '}
            <a href={`mailto:${ARVORE_EMAIL}`}>{ARVORE_EMAIL}</a> ou WhatsApp{' '}
            <a
              href="https://wa.me/5521981661218"
              target="_blank"
              rel="noopener noreferrer"
            >
              (21) 98166-1218
            </a>
            .
          </>
        )}
        <CustomButton
          data-testid="close-button"
          primary
          medium
          onClick={dismissModal}
        >
          Entendi
        </CustomButton>
      </Content>
    </StyledModal>
  )
}

export default ModalNotYourSchool
